import { TaskRecurrenceType } from 'Generated/graphql-types'
import {
  TimeUnitSubTypeEnum,
  OnUpdateOptions,
  RecurrenceOptions as RecurrenceOptionsType,
} from '../types'
import { MonthlyOptions } from './MonthlyOptions'
import { QuarterlyOptions } from './QuarterlyOptions'
import { WeeklyOptions } from './WeeklyOptions'

type RecurrenceOptionsProps = {
  dayOfMonth: RecurrenceOptionsType['dayOfMonth']
  dayOfWeek: RecurrenceOptionsType['dayOfWeek']
  recurrenceType: TaskRecurrenceType
  timeUnitSubType: TimeUnitSubTypeEnum
  onUpdateOptions: OnUpdateOptions
  weekOfMonth: RecurrenceOptionsType['weekOfMonth']
}

export const RecurrenceOptions = ({
  dayOfMonth,
  dayOfWeek,
  recurrenceType,
  timeUnitSubType,
  onUpdateOptions,
  weekOfMonth,
}: RecurrenceOptionsProps) => {
  switch (recurrenceType) {
    case TaskRecurrenceType.Weekly:
      return (
        <WeeklyOptions
          onUpdateOptions={onUpdateOptions}
          dayOfWeek={dayOfWeek}
        />
      )
    case TaskRecurrenceType.Monthly:
      return (
        <MonthlyOptions
          dayOfMonth={dayOfMonth}
          timeUnitSubType={timeUnitSubType}
          onUpdateOptions={onUpdateOptions}
          weekOfMonth={weekOfMonth}
          dayOfWeek={dayOfWeek}
        />
      )
    case TaskRecurrenceType.Quarterly:
      return (
        <QuarterlyOptions
          dayOfMonth={dayOfMonth}
          onUpdateOptions={onUpdateOptions}
        />
      )
    default:
      return null
  }
}
